import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import homePage from './homePage'

import hashUrl from './hashUrl'
import globalState from './globalState'
import login from './login'

const rootReducer = combineReducers({
    routing: routerReducer,
    homePage,
    globalState,
    hashUrl,
	login,
})

export default rootReducer





// WEBPACK FOOTER //
// ./reducers/index.js